// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const BULK_IMPORT_STEP_SHAPES = [
  {
    stepType: PipelineStepType.BULK_IMPORT,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input file': {
        systemName: 'Input file',
        displayName: 'Input file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Results file': {
        systemName: 'Results file',
        displayName: 'Results file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      },
      'Errors file': {
        systemName: 'Errors file',
        displayName: 'Errors file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      objectType: {
        kind: 'string',
        required: true
      },
      bulkMethodType: {
        kind: 'enum',
        required: true,
        choices: [
          {
            value: 'CREATE',
            displayName: 'Create'
          },
          {
            value: 'UPDATE',
            displayName: 'Update'
          },
          {
            value: 'CUSTOM',
            displayName: 'Custom method'
          }
        ]
      },
      customMethodName: {
        kind: 'string',
        required: false
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
